import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import parkaveImg from '../../assets/images/parkoutside.jpg';

function ParkAve() {
    return <StoreTemplate storeData={storeData.parkave} storeImage={parkaveImg} />;
}

export default ParkAve; 